import * as types from '../actions/actionTypes';
import SessionFlowTypes from '../constants/sessionFlowTypes';

const defaultPatientPoolOption = { uniqueToken: '', displayName: "Select a patient pool" };

const initialState = {
	correlationKey: null,
	decisionSupportSessionData: {
		dataPoolFields: null,
		effectiveFlowVersion: null,
		elementSet: null,
		enablePreviousButton: false,
		eventLog: null,
		finishedDueToKickout: false,
		flowId: null,
		flowSessionId: null,
		hasValidationErrors: false,
		hasWarnings: false,
		isFlowAtInputStage: false,
		isFlowAtStart: false,
		isFlowFinished: false,
		kickoutMessage: null,
		results: {
			fields: [],
		},
		supportedFlowInputs: null,
		validationMessages: [],
		validationWarnings: null,
	},
	decisionSupportSessionId: null,
	isDecisionSupportSessionSavedToCareOrder: false,
	schedulingSessionFlowType: "",
	decisionSupportSubpoints: null,
	sessionId: null,
	workboxId: null,
	patientPools: [],
	locationEntryPoint: {
		sites: [],
		patientPoolUniqueToken: null,
		patientPoolDisplayName: null,
		patientPoolPrefix: null,
		isPatientPoolLocked: false,
	},
	appointmentFirstMode: false,
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case types.GET_COMPLETED_DECISION_SUPPORT_SESSION_PAYLOAD_SUCCESS:
			return {
				...state,
				decisionSupportSessionData: action.payload.data,
				decisionSupportSessionId: action.payload.data.flowSessionId,
				decisionSupportSubpoints: mapFlowSessionResponseToSubpoints(action.payload.data)
			};
		case types.WORKFLOW_CORRELATION_KEY_UPDATED:
			return {
				...state,
				correlationKey: action.correlationKey,
				decisionSupportSessionId: null,
				isDecisionSupportSessionSavedToCareOrder: false,
				decisionSupportSubpoints: null,
				workboxId: null,
			};
		case types.GUIDED_RESPONSE_START_FLOW_SUCCESS:
		case types.GUIDED_RESPONSE_CONTINUE_FLOW_SUCCESS:
			return {
				...state,
				decisionSupportSessionId: action.payload.data.flowSessionId,
				workboxId: null,
				schedulingSessionFlowType: SessionFlowTypes.newFlow
			};
		case types.PATIENT_SEND_CARE_ORDER_NOTIFICATION_SUCCESS:
		case types.APPOINTMENT_BOOK_SUCCESS:
			return {
				...state,
				correlationKey: null,
				decisionSupportSessionData: null,
				decisionSupportSessionId: null,
				isDecisionSupportSessionSavedToCareOrder: false,
				decisionSupportSubpoints: null,
				workboxId: null,
				appointmentFirstMode: false,
			};
		case types.CREATE_CARE_ORDER_FROM_DECISION_SUPPORT_OUTPUTS_SUCCESS:
			return {
				...state,
				isDecisionSupportSessionSavedToCareOrder: true,
			}
		case types.SET_SCHEDULING_SESSION_FLOW_TYPE:
			return {
				...state,
				schedulingSessionFlowType: action.schedulingSessionFlowType
			}
		case types.GET_PATIENT_POOLS_SUCCESS:
			return {
				...state,
				patientPools: action.payload.data.length > 1 ? [defaultPatientPoolOption, ...action.payload.data.sort((a, b) => (a.displayName > b.displayName) ? 1 : -1)] : action.payload.data
			}
		case types.SET_LOCATION_ENTRY_POINT:
			return {
				...state,
				locationEntryPoint: {
					...initialState.locationEntryPoint,
					...action.locationEntryPoint,
				}
			}
		case types.CLEAR_LOCATION_ENTRY_POINT:
			return {
				...state,
				locationEntryPoint: initialState.locationEntryPoint
			}
		case types.SET_APPOINTMENT_FIRST_MODE:
			return {
				...state,
				appointmentFirstMode: action.appointmentFirstMode,
			};
		case types.CLEAR_BOOKING_CONTEXT:
			// Leaving a booking context also leaves appointment-first mode. Returns the same state
			// reference when the mode is already off, so this is inert for every other flow.
			return state.appointmentFirstMode ? { ...state, appointmentFirstMode: false } : state;
		default:
			return state;
	}
}

function mapFlowSessionResponseToSubpoints(flowSessionResponse) {
	let results = flowSessionResponse.results.fields;
	let subpoints = [];

	results.forEach(field => {
		let subpoint = { key: field.fieldName.toLowerCase(), value: field.currentValue };
		subpoints.push(subpoint);
	});

	return subpoints;
}